module.exports = __webpack_public_path__ + "img/config.7ae4d8ee.svg";